
import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import './index.scss';


interface IState {
  url: string;
}
class RedirectHelpdeskPage extends React.Component<RouteComponentProps<any>, IState> {
  constructor(props) {
    super(props);
    this.state = { url: "https://www.10studio.tech/docs/helpdeskAndContact" };

  }
  render() {



    return (
      <div className="redirectPageContainer">
        <div className="container">
          <div className="row" >
            <PrimaryButton className="btn-success"
              text="Helpdesk & Contact"
              onClick={() => {
                window.open(this.state.url);
              }}
            />
          </div>
          <div className="row">
            <p>
             Check out our online video courses for spreadsheet programming in general:
            </p>

            <PrimaryButton 
              text="Spreadsheet Language and Programming (English version)"
              onClick={() => {
                window.open("https://go.10studio.tech/5A4qUB");
              }}
            />

            <PrimaryButton 
              text="表格语言和编程（中文版）"
              onClick={() => {
                window.open("https://go.10studio.tech/T14Czy");
              }}
            />

          </div>
          
        </div></div>

    );

  }
}

export default withRouter(RedirectHelpdeskPage);